// Real volunteer reviews scraped from volunteering.org.au/volunteer-abroad-reviews/
// and the individual story pages. 42 stories.
const U = "/assets/img/";

export const REVIEW_BADGES = [
  { source: "Volunteer World", score: "4.7", detail: "269 reviews", note: "Trusted Partner" },
  { source: "Go Overseas", score: "97.4%", detail: "201 alumni reviews", note: "Recommended" },
  { source: "APAC Insider", score: "Top Org", detail: "Australia awards", note: "Winner 2019" },
];

export const FEATURED_REVIEWS = [
  {
    id: "f1",
    name: "Alex",
    country: "Fiji",
    program: "Remote Island Teaching",
    img: U + "2019-06-fiji-school-classroom.jpg",
    quote:
      "My host family were incredible, so generous with everything they had. They answered my questions, talked to me, laughed with me and my two Fijian \u201cbrothers\u201d I had for two weeks, I will never forget. I left Fiji feeling like I was a part of their family. The teaching staff were so appreciative of everything I did.",
  },
  {
    id: "f2",
    name: "Franziska",
    country: "Nepal",
    program: "Stray Dog Shelter",
    img: U + "2023-01-volunteer-with-dog-in-nepal-min-1.webp",
    quote:
      "This was by far the most valuable experience. The people at the Kat Centre are the best, they are doing such an amazing job and were really welcoming and appreciative of my work there. But the most fulfilling was to see the dogs change and looking forward to me taking them for a walk everyday.",
  },
  {
    id: "f3",
    name: "Stephanie",
    country: "Fiji",
    program: "Nutrition Outreach",
    img: U + "2019-06-stephanie-doing-health-check-in-fiji.jpg",
    quote:
      "Oh so blessed to work with a bunch of likeminded legends to complete health checks on the local Fijian people. A humbling and awakening experience with a little reminder that not all are as lucky as we are in the western world, but smile always and everything works out on Fiji time. I leave with a full heart.",
  },
];

export const TESTIMONIALS = [
  {
    id: "t1",
    name: "Maitreyi",
    country: "Bali",
    program: "Turtle Conservation",
    date: "July 2026",
    img: U + "2016-02-turtle-1.jpg",
    quote:
      "Volunteering was the best experience of my life! The turtles are so cute and it was very fulfilling to take care of them. I met loads of amazing people, visited places that looked absolutely out of this world, and gained lots of independence. The coordinators are amazing: easygoing, funny, dedicated and always there to make you smile.",
  },
  {
    id: "t2",
    name: null,
    country: "Fiji",
    program: "Remote Island Teaching",
    date: "July 2026",
    img: U + "2023-03-remote-island-teaching-fiji.-2-scaled-min-1-300x225.webp",
    quote:
      "Volunteering on the island was the most life changing and incredible experience. From the moment I arrived on the island I felt welcomed and loved by every person! I was lucky to teach in a classroom I will never forget.",
  },
  {
    id: "t3",
    name: null,
    country: "Kenya",
    program: "Kindergarten",
    date: "July 2026",
    img: U + "2020-01-group-of-kindergaten-kids-with-thier-plastic-drink-cups-2-min-1-300x200.webp",
    quote:
      "I had the pleasure to work in a kindergarten in Kenya. I am 21 years old and from Hamburg, Germany. The project is located in Central Kenya and it takes about one hour to get there every minute was worth it.",
  },
  {
    id: "t4",
    name: null,
    country: "Costa Rica",
    program: "Family Volunteering",
    date: "July 2026",
    img: U + "2019-11-medical-healthcare-volunteer-abroad-8-min-300x188.webp",
    quote:
      "Review by a family group (husband, wife and 16 year old son). Our volunteer experience is very hard to sum up in a few words the highlights kept coming, and doing it together as a family made it unforgettable.",
  },
  {
    id: "t5",
    name: "Anna",
    country: "Nepal",
    program: "Buddhist Monastery Teaching",
    date: "July 2026",
    img: U + "2020-01-group-of-monks-with-mountain-backdrop-300x146.jpg",
    quote:
      "I\u2019m Anna, 26, from Luxembourg. My passion is to explore new countries and cultures. Teaching at the monastery, surrounded by those mountains, was the most peaceful and grounding month of my life.",
  },
  {
    id: "t6",
    name: null,
    country: "Kenya",
    program: "Wildlife Conservation",
    date: "June 2026",
    img: U + "2025-04-8becec13-d80e-497f-b416-34f9b55d5de3-1-225x300.jpeg",
    quote:
      "The trip was so interesting in terms of the diverse activities we did and the animals we could see. It was a dream to see the savanna and the animals and we had the best local team with us the whole way.",
  },
  {
    id: "t7",
    name: "Tricia",
    country: "Bali",
    program: "Turtle Conservation, Nusa Penida",
    date: "June 2026",
    img: U + "2020-02-turtles-300x169.jpg",
    quote:
      "I loved working with the turtles, they are SO cute! It was a lot of fun meeting all the other volunteers and getting to know them.",
  },
  {
    id: "t8",
    name: null,
    country: "Fiji",
    program: "Island Teaching & Orphanage",
    date: "June 2026",
    img: U + "2023-03-remote-island-teaching-fiji-300x225.jpg",
    quote:
      "Loved it. Amazing opportunity and honour to be welcomed as a local in the village. An honour to live with them in community that was definitely my highlight. Absolutely would do it again.",
  },
  {
    id: "t9",
    name: null,
    country: "Kenya",
    program: "Wildlife Conservation",
    date: "June 2026",
    img: U + "2024-09-vollies-by-truck-in-kenya-300x169.jpeg",
    quote:
      "The best experience I ever had in Kenya. Amazing project, lovely people, very kind staff, a lot of options for activities and delicious Kenyan food. The local team was fantastic they help you with everything.",
  },
  {
    id: "t10",
    name: "Joseph",
    country: "Fiji",
    program: "Sports & Kindergarten, Sigatoka",
    date: "June 2026",
    img: U + "2022-09-volunteer-with-sports-group-300x150.jpg",
    quote:
      "Great opportunity to work with other like minded volunteers to assist with child learning and development in both classroom and community sport settings. All round very good. Local team very supportive.",
  },
  {
    id: "t11",
    name: "Toni",
    country: "Madagascar",
    program: "Lemur Conservation",
    date: "May 2026",
    img: U + "2026-05-PHOTO-2026-05-11-17-22-54-272x300.jpg",
    quote:
      "I chose to spend one week volunteering with lemurs at Lemuria Land, a sanctuary in Madagascar. The green space houses about 10 species of lemur waking up to their calls is something I will never forget.",
  },
  {
    id: "t12",
    name: null,
    country: "Thailand",
    program: "Sports Coaching",
    date: "March 2026",
    img: U + "2025-04-Lovina-Sports-Coaching-2-300x225.jpg",
    quote:
      "Volunteering in Thailand was a very rewarding experience and a great way to explore the country. Meeting people from all over the world and various walks of life was also very nice. Definitely one to remember.",
  },
  {
    id: "t13",
    name: null,
    country: "Vietnam",
    program: "Soup Kitchen, Saigon",
    date: "March 2026",
    img: U + "2026-03-Soup-Kitchen-Saigon-1-300x225.jpeg",
    quote:
      "Volunteering in one of the soup kitchens in Saigon, to help feed many hundreds of vulnerable and disadvantaged people, was a humbling but truly wonderful experience. Working alongside local volunteers, sharing preparation, was the best part.",
  },
  {
    id: "t14",
    name: null,
    country: "Fiji",
    program: "Community Construction",
    date: "March 2026",
    img: U + "2026-03-Construction-in-Fiji-300x225.jpg",
    quote:
      "The work was demanding but rewarding. I left the accommodation at 7am and returned about 5.30pm; a long day when afternoon shade temperatures are 30 degrees. A good degree of satisfaction at the end of it.",
  },
  {
    id: "t15",
    name: null,
    country: "India",
    program: "Medical Internship, Goa",
    date: "March 2026",
    img: U + "2024-10-GoaMedicalInternship123-300x225.jpg",
    quote:
      "Our coordinators were super nice and helped us along the whole project. The JMJ Hospital was great and Goa had some lovely beaches. We really enjoyed our experience with the team.",
  },
  {
    id: "t16",
    name: null,
    country: "Fiji",
    program: "Nutrition Internship",
    date: "February 2026",
    img: U + "2026-02-PHOTO-2026-02-06-17-16-45-225x300.jpg",
    quote:
      "Volunteering or interning abroad is more than just travel it\u2019s an opportunity to grow, connect and create a meaningful impact. IVI is committed to ethical, community-driven programs and you feel that on the ground.",
  },
  {
    id: "t17",
    name: null,
    country: "Sri Lanka",
    program: "Turtle Rehabilitation",
    date: "January 2026",
    img: U + "2020-01-taking-care-of-the-turtles-in-the-tanks-300x200.jpg",
    quote:
      "I spent 9 weeks at the turtle conservation in Ambalangoda and 2 weeks at the special needs program in Kandy. My experience was truly amazing working with the turtles was so much fun.",
  },
  {
    id: "t18",
    name: "Stephanie",
    country: "Thailand",
    program: "Elephant Conservation, Koh Samui",
    date: "January 2026",
    img: U + "2025-03-Koh-Samui-Elephant-Care-Program-16-287x300.jpg",
    quote:
      "The volunteer program was absolutely amazing. We were guided patiently on how to take care of the elephants. Everyone there was extremely friendly. This experience is definitely once in a lifetime.",
  },
  {
    id: "t19",
    name: null,
    country: "Bali",
    program: "Environmental & English Teaching",
    date: "January 2026",
    img: U + "2026-01-Bali-teaching-3-300x225.jpg",
    quote:
      "It was an incredible trip. I had a wonderful time volunteering the people were so lovely, and the children are truly amazing. Working with the kids was especially rewarding; they were always excited to see us.",
  },
  {
    id: "t20",
    name: null,
    country: "South Korea",
    program: "Childcare & After School Support",
    date: "October 2025",
    img: U + "2025-10-south-korea-childcare-volunteering-2-225x300.jpg",
    quote:
      "I volunteered for a month. Every Monday we would meet up in the lobby to plan our English lesson materials for the rest of the week. The structure made it easy to actually be useful.",
  },
  {
    id: "t21",
    name: null,
    country: "Laos",
    program: "Community Construction",
    date: "October 2025",
    img: U + "2025-10-0e0fdedc-bdef-42f9-9615-6c6d22b0713b-300x225.jpeg",
    quote:
      "The trip was amazing. Highlights definitely included getting to know the Laos people and culture. Spending a couple of days a week helping out at the local school and the rest on the build was the perfect mix.",
  },
  {
    id: "t22",
    name: "Jin's team",
    country: "South Korea",
    program: "Childcare Program",
    date: "October 2025",
    img: U + "2025-07-Childcare-South-Korea-2-300x225.jpg",
    quote:
      "I found the supervisors per email and on site to be very friendly and helpful. Jin, in particular, assisted me greatly. The children were very sweet and open to learning. I also felt secure the whole time.",
  },
  {
    id: "t23",
    name: null,
    country: "Fiji",
    program: "Teaching as a Family of 4",
    date: "October 2025",
    img: U + "2017-01-photo2-1-300x225.jpg",
    quote:
      "Such an amazing experience the welcome to the village and local culture was very special. The school and teachers were incredible, and what I hadn\u2019t planned for was how great it would be for our kids.",
  },
  {
    id: "t24",
    name: null,
    country: "Thailand",
    program: "Childcare, Hua Hin",
    date: "September 2025",
    img: U + "2024-05-games-at-hua-hin-kindy-300x225.jpg",
    quote:
      "Working with the children in the kindergarten was great, and I also really enjoyed being in different groups. I learned a lot of new things and would do it again in a heartbeat.",
  },
  {
    id: "t25",
    name: null,
    country: "Thailand",
    program: "Kindergarten, Chiang Mai",
    date: "September 2025",
    img: U + "2025-09-kindy-chiang-mai-class-2-300x225.jpeg",
    quote:
      "I loved it. The children were well behaved and had good support from the people that worked there. Good transport to locations as well.",
  },
  {
    id: "t26",
    name: null,
    country: "Thailand",
    program: "Environmental, Hua Hin",
    date: "September 2025",
    img: U + "2025-09-IMG_8583-225x300.png",
    quote:
      "It was a wonderful experience! So many people from all over the world! We enjoyed every moment of our project from cleaning the beach to planting new mangroves!",
  },
  {
    id: "t27",
    name: null,
    country: "Philippines",
    program: "Medical Internship, Leyte",
    date: "August 2025",
    img: U + "2025-08-IMG_20250818_091707_547-225x300.jpg",
    quote:
      "At the clinic I was taught different nursing techniques under supervision placing IV lines, vaccinating, suturing, taking vital signs. This was truly useful when going to rural areas where access to hospitals does not exist.",
  },
  {
    id: "t28",
    name: null,
    country: "South Africa",
    program: "Cheetah Conservation",
    date: "August 2025",
    img: U + "2025-05-Cheetah-relax-300x200.jpg",
    quote:
      "At Ashia, I supported a loving team with daily tasks such as keeping the enclosures clean, preparing food and feeding the kittens. Nice and clean accommodation, fresh food, wonderful people.",
  },
  {
    id: "t29",
    name: null,
    country: "Bali",
    program: "Turtle Program, Nusa Penida",
    date: "August 2025",
    img: U + "2024-10-hatchlings-240x300.png",
    quote:
      "I did volunteering in Nusa Penida for the turtle conservation program and I enjoyed it a lot. I really liked the experience of volunteering and learning something new about the turtles and the culture.",
  },
  {
    id: "t30",
    name: null,
    country: "Thailand",
    program: "School Construction, Hua Hin",
    date: "August 2025",
    img: U + "2024-04-email-blocks-2-3-300x200.jpg",
    quote:
      "I really enjoyed the experience. The team was amazing, the people I met along the way really made a difference. The project was fun and seeing the kids like our work was heartfelt.",
  },
  {
    id: "t31",
    name: null,
    country: "Sri Lanka",
    program: "Turtle Conservation",
    date: "August 2025",
    img: U + "2025-08-IMG_4444-225x300.png",
    quote:
      "In search of a meaningful holiday I selected volunteering in Sri Lanka and it was the best decision! Every day was an adventure, a discovery, a surprise. Not only have I enjoyed working with the turtles, I made friends for life.",
  },
  {
    id: "t32",
    name: null,
    country: "Japan",
    program: "English Exchange, Otaki Village",
    date: "July 2025",
    img: U + "2025-07-4CC07E6B-32D1-4205-9AB6-12100C9407BC-169x300.jpeg",
    quote:
      "For 2 weeks I volunteered in Otaki Village, a rural town hidden near Kiso-Fukushima in Nagano Prefecture. I worked with the team helping local students learn English through conversation such a warm community.",
  },
  {
    id: "t33",
    name: null,
    country: "Fiji",
    program: "Sports Teaching",
    date: "July 2025",
    img: U + "2025-07-IMG_6664-300x225.jpg",
    quote:
      "Volunteering in Fiji was the most amazing experience. I thoroughly enjoyed each and every moment! The local team were friendly and welcoming, providing great food and company.",
  },
  {
    id: "t34",
    name: null,
    country: "Fiji",
    program: "Remote Island Teaching",
    date: "July 2025",
    img: U + "2025-07-remote-island-teaching-fiji-6-300x225.jpg",
    quote:
      "The island is a special place for me. Since this is my second visit this year, I can see the children growing into such brilliant and capable people. I taught them to paint and they taught me plenty.",
  },
  {
    id: "t35",
    name: null,
    country: "Fiji",
    program: "Childcare",
    date: "June 2025",
    img: U + "2025-06-Fiji-Childcare-8-300x225.jpeg",
    quote:
      "The volunteering trip was truly amazing and eye-opening. Getting to know the local people and their culture really made this trip so significant for me. The volunteering work with the kids was amazing.",
  },
  {
    id: "t36",
    name: null,
    country: "Thailand",
    program: "English Teaching, Koh Samui",
    date: "June 2025",
    img: U + "2024-12-Koh-Samui-Teaching-1-300x135.jpg",
    quote:
      "The volunteering was so much fun! The kids were super cute and loved to learn new things. The teachers at the school and the local guides at the accommodation help so much.",
  },
  {
    id: "t37",
    name: null,
    country: "Nepal",
    program: "Education, Kathmandu",
    date: "May 2025",
    img: U + "2020-04-Education-Kathmandu-NP-Feb-11.jpg",
    quote:
      "Teaching outside with the Himalayas in the background is not something you forget. The kids were endlessly curious and the IVI coordinator checked in on us constantly.",
  },
  {
    id: "t38",
    name: null,
    country: "Guatemala",
    program: "Kindergarten",
    date: "April 2025",
    img: U + "2020-03-kindergarten-guatemala-17.jpg",
    quote:
      "A child sat on my lap on day one and did not move for three weeks. The families welcomed us into their homes and I came home with far more than I gave.",
  },
  {
    id: "t39",
    name: null,
    country: "Nepal",
    program: "Teen Group Program",
    date: "March 2025",
    img: U + "2019-07-amazing-Nepal_-19-1-1-scaled.jpg",
    quote:
      "Our school group of 19 trekked, taught and built together. Watching teenagers realise how big and generous the world is worth every minute of the planning.",
  },
  {
    id: "t40",
    name: null,
    country: "Sri Lanka",
    program: "Tea Farm Community",
    date: "February 2025",
    img: U + "2020-02-Group-photo-at-tea-farm-1.jpg",
    quote:
      "Working with the tea pickers changed how I look at my morning cup. The group photo at the farm is still my phone wallpaper two years later.",
  },
  {
    id: "t41",
    name: null,
    country: "India",
    program: "Rural Community Support, Bodhgaya",
    date: "January 2025",
    img: U + "2016-06-bodhgaya-crew3.jpg",
    quote:
      "Our crew ran health checks and distributed safe birthing kits in villages around Bodhgaya. Hard days, incredible people, and a team I would go back with tomorrow.",
  },
  {
    id: "t42",
    name: null,
    country: "Guatemala",
    program: "Medical Internship",
    date: "December 2024",
    img: U + "2020-03-medical-guatemala-1-1024x576.jpeg",
    quote:
      "Scrubs on, straight into the rural clinic. I saw and did more in four weeks than in a year of study, always supervised and always supported.",
  },
];

export const REVIEW_COUNTRIES = [
  "All",
  ...Array.from(new Set(TESTIMONIALS.map((t) => t.country))).sort(),
];
